import React from 'react';
import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import ReactivateButton from '../ReactivateButton';
import { appEnv } from '../../../utils/env';

import styles from './ReactivateTodayDisclaimer.module.scss';

const ReactivateTodayDisclaimer = ({ isLoading, setIsLoading, setShowRetry }) => {
  return (
    <div className={styles.reactivateTodayDisclaimer} data-testid="reactivate-today-disclaimer">
      <Disclaimer name={DISCLAIMER_NAMES.reactivateToday1} env={appEnv} />
      <ReactivateButton
        text="REACTIVATE ME"
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setShowRetry={setShowRetry}
      />
      <Disclaimer name={DISCLAIMER_NAMES.reactivateToday2} env={appEnv} />
    </div>
  );
};

export default ReactivateTodayDisclaimer;
